import { render } from "./CreateUserRole.vue?vue&type=template&id=7c136b5b"
import script from "./CreateUserRole.vue?vue&type=script&lang=js"
export * from "./CreateUserRole.vue?vue&type=script&lang=js"

import "./CreateUserRole.vue?vue&type=style&index=0&id=7c136b5b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__